var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5, _path6, _path7, _path8, _path9, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrantJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    x1: 65.44,
    y1: 134.85,
    x2: 120.52,
    y2: 134.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    "data-name": "C_BG_shellbar",
    x1: 50.27,
    y1: 110.55,
    x2: 60.96,
    y2: 110.55,
    xlinkHref: "#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    "data-name": "C_BG_shellbar",
    x1: 50.27,
    y1: 90.24,
    x2: 60.96,
    y2: 90.24,
    xlinkHref: "#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    "data-name": "C_BG_shellbar",
    x1: 50.27,
    y1: 69.93,
    x2: 60.96,
    y2: 69.93,
    xlinkHref: "#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    "data-name": "C_BG_shellbar",
    x1: 50.27,
    y1: 49.62,
    x2: 60.96,
    y2: 49.62,
    xlinkHref: "#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092",
    "data-name": "C_BG_shellbar",
    x1: 100.69,
    y1: 120.04,
    x2: 161.57,
    y2: 120.04,
    xlinkHref: "#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)",
    d: "M66.69 134.85h52.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M136.75 94.63V31.58H54.88l.06 102.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M113.06 128.65H61.15c-3.42 0-6.21 2.79-6.21 6.21s2.79 6.21 6.21 6.21h64.33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 63.76,
    cy: 110.55,
    r: 4.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 63.76,
    cy: 90.24,
    r: 4.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 63.76,
    cy: 69.93,
    r: 4.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 63.76,
    cy: 49.62,
    r: 4.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 MI_4L_gradient",
    stroke: "url(#SVGID_1_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)",
    d: "M51.52 110.55h8.19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1 MI_4L_gradient",
    stroke: "url(#SVGID_2_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)",
    d: "M51.52 90.24h8.19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 MI_4L_gradient",
    stroke: "url(#SVGID_3_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)",
    d: "M51.52 69.93h8.19"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 MI_4L_gradient",
    stroke: "url(#SVGID_4_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)",
    d: "M51.52 49.62h8.19"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5 MI_4L_gradient",
    d: "M155.31 122.54l-24.17 24.18-24.18-24.18c-6.68-6.68-6.68-17.5 0-24.17 6.68-6.68 17.5-6.68 24.18 0 6.68-6.68 17.49-6.68 24.17 0 6.68 6.67 6.68 17.5 0 24.17z",
    stroke: "url(#SVGID_5_b9251ee1ad1a856c736032afa7c71204093b62a454adcc712b0cf6b6fa16e092)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M136.3 115.14s-.85-4.91-4.91-4.91-5.16 4.91-5.16 4.91l10.55 8M126.72 123.14s.85 4.91 4.91 4.91 5.16-4.91 5.16-4.91M131.51 106.04v4.18M131.51 128.05v4.19M88.57 53.95h26.38M92.97 59.49h16.93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_main",
    x: 77.33,
    y: 45.61,
    width: 48.37,
    height: 22.72,
    rx: 5.86,
    ry: 5.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantJournal);
export default __webpack_public_path__ + "static/media/grantJournal.90ffa4ab91fa7744ca2e3eca84d110be.svg";
export { ForwardRef as ReactComponent };